import React, { ComponentProps } from 'react';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { BlockInteractions } from '../../components/organisms/BlockInteractions';
import { RolePrivilegeConfigurationDefaultView } from './views/RolePrivilegeConfigDefaultView';

type RolePrivilegeConfigurationProps = Views<DefaultView<RolePrivilegeConfigurationDefaultView>>;

function RolePrivilegeConfiguration({ views, activeView }: RolePrivilegeConfigurationProps) {
  const { t } = useSonTranslation('RolePrivilegeConfig');
  const { uuid, elementType } = useBlockContext();
  const { refreshCount } = useRefreshBlock();

  return (
    <BlockInteractions
      key={refreshCount}
      headline={{
        text: t('headline'),
        visible: true,
        hierarchy: 3,
      }}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      uuid={uuid}
      elementType={elementType}
    >
      <RolePrivilegeConfigurationDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const RolePrivilegeConfigBlock = asFetchableBlock(RolePrivilegeConfiguration, BlockType.roleprivilegeconfig);
export type RolePrivilegeConfigBlock = ComponentProps<typeof RolePrivilegeConfigBlock>;
